// Detached zero-time metadata projection shared by Manual saves and AI drafts.
export const visitMetadata = day => {
  if (day?.locationVisits === undefined) return {};
  const ids = new Set((day.entries || []).map(e => e.id));
  return { locationVisits: day.locationVisits.map(v => ({ ...v, position: Math.min(v.position, (day.entries || []).length), occurrenceIds: v.occurrenceIds.filter(id => ids.has(id)) })) };
};
export const proposalDayMetadata = (day, fresh) => fresh && !day.isContext
  ? { ...day, locations: day.locations || [], locationVisits: day.locationVisits || [] }
  : day;// Strict value comparison of saved visits; property order (server schema order) is irrelevant.
const visitKey = v => [v.id, v.locationRef, v.position, [...(v.occurrenceIds || [])], v.notes || ''];
export const sameVisits = (saved, sent) => Array.isArray(saved) && Array.isArray(sent) && saved.length === sent.length
  && JSON.stringify(saved.map(visitKey)) === JSON.stringify(sent.map(visitKey));
// Day Details location edits: idMap maps each kept original location ID to its saved ID.
// Cards on removed locations are dropped (their scenes/activities stay); cards on relinked locations follow the new ID.
export const reconcileDayVisits = (day, idMap) => {
  if (day?.locationVisits === undefined) return { locationVisits: undefined, removed: [] };
  const removed = day.locationVisits.filter(v => !idMap.has(v.locationRef));
  const locationVisits = day.locationVisits.filter(v => idMap.has(v.locationRef)).map(v => ({ ...v, locationRef: idMap.get(v.locationRef) }));
  return { locationVisits, removed };
};
